/* eslint-disable react-hooks/exhaustive-deps */
import { JitsiMeeting } from "@jitsi/react-sdk";

import { DataProvider } from "@/api/DataProvider";
import { LoadingWrapper } from "@/components/shared/LoadingWrapper";
import EnvironmentConfigs from "@/configs";
import { AuthEnums } from "@/enums/Enums";
import { useMeetActions, useMeetDetail } from "@/store/selectors/MeetSelectors";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router";
import SelectLoginMode from "./SelectLoginMode";

const MeetPage = () => {
  const navigate = useNavigate();
  const { meetingId } = useParams();
  const [searchParams] = useSearchParams();
  const environments = EnvironmentConfigs();

  const meetDetail = useMeetDetail();
  const { setMeetDetail } = useMeetActions();

  const [jitsiToken, setJitsiToken] = useState<string | null>(null);

  useEffect(() => {
    if (searchParams.get("token")) {
      setMeetDetail({
        token: searchParams.get("token"),
        mode: AuthEnums.Token,
      });
    }
  }, [searchParams, setMeetDetail]);

  useEffect(() => {
    if (meetDetail.token && meetDetail.info && meetingId) {
      getMeetJwtToken({
        token: meetDetail.token,
        tenantName: meetDetail.info?.tenant_name || "",
      });
    }
  }, [meetDetail.token, meetDetail.mode, meetingId]);

  const getMeetJwtToken = async ({
    token,
    tenantName,
  }: {
    token: string;
    tenantName: string;
  }) => {
    try {
      const res = await DataProvider.getList(
        `v1/tokens/${meetingId}/jitsi-token`,
        {},
        "",
        token
      );
      if (res?.token) {
        setJitsiToken(res.token);
        navigate(`/${meetingId}`);
      } else {
        resetMode();
      }
    } catch (error) {
      resetMode();
      return;
    }
  };

  const resetMode = () => {
    setMeetDetail({
      token: null,
      mode: AuthEnums.Select,
    });

    window.location.href = window.location.origin + window.location.pathname;
  };

  const handleApiReady = (externalApi: any) => {
    console.log("API is ready", externalApi);
    // externalApi.addEventListener("toolbarButtonClicked", (event: any) => {
    //   if (event.key === "invite") {
    //     const customMeetingLink = window.location.href;

    //     // Override clipboard or show custom modal
    //     navigator.clipboard.writeText(customMeetingLink);
    //   }
    // });
  };

  const iframe = useMemo(() => {
    // console.log(environments.meetUrl.replace("https://", "").replace("/", ""));
    const userInfoProps =
      meetDetail.mode === AuthEnums.Guest && meetDetail.displayName
        ? {
            userInfo: {
              displayName: meetDetail.displayName,
              email: null,
            },
          }
        : {};

    return (
      <JitsiMeeting
        domain={environments.meetUrl.replace("https://", "").replace("/", "")}
        roomName={meetingId}
        jwt={jitsiToken}
        getIFrameRef={(iframeRef) => {
          iframeRef.style.height = "100dvh";
          iframeRef.style.width = "100dvw";
          iframeRef.style.border = "none";
          iframeRef.style.position = "absolute";
        }}
        configOverwrite={{
          startWithAudioMuted: false,
          startWithVideoMuted: true,
        }}
        onApiReady={handleApiReady}
        {...userInfoProps}
      />

      // <iframe
      //   title="jitsi"
      //   src={`${environments.meetUrl}/${meetingId}${
      //     meetDetail.mode !== AuthEnums.Guest ? `?jwt=${jitsiToken}` : ""
      //   }`}
      //   style={{
      //     width: "100vw",
      //     height: "100dvh",
      //     border: "none",
      //   }}
      //   sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation-by-user-activation"
      //   allow="clipboard-read; clipboard-write *"
      // />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    environments?.meetUrl,
    meetingId,
    jitsiToken,
    meetDetail?.mode,
    meetDetail?.displayName,
  ]);

  if (
    meetDetail.mode === AuthEnums.Select ||
    meetDetail.mode === AuthEnums.EnterName
  ) {
    return <SelectLoginMode />;
  }

  if (!jitsiToken && meetDetail.mode !== AuthEnums.Guest) {
    return <LoadingWrapper />;
  }

  return iframe;
};

export default MeetPage;
